import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

import { DASHBOARD_PAGE_PATH, ERROR403_PAGE_PATH, LOGIN_PAGE_PATH } from '../constants/appPathConst';
import {
  hasFirstAccessiblePage,
  isAuthorizedForRoute,
  performLogout,
  retrieveAuthToken,
  retrieveUserDetails
} from '../generalUtils/rbacUtils';

const redirectTo = path => <Navigate to={path} test={'test'} />;

const RouteAuthMiddleware = () => {
  const location = useLocation();

  const authToken = retrieveAuthToken();
  const user = retrieveUserDetails();

  if (!authToken || !user) {
    performLogout();
    return redirectTo(LOGIN_PAGE_PATH);
  }

  const url = location?.pathname || '';
  const secondSlashIndex = url.indexOf('/', 1);
  const pagePathURL = secondSlashIndex !== -1 ? url.substring(0, secondSlashIndex) : url;

  const isAccessable = isAuthorizedForRoute({ pathurl: pagePathURL });
  if (isAccessable) {
    return <Outlet />;
  } else {
    if (url === DASHBOARD_PAGE_PATH) {
      const path = hasFirstAccessiblePage();
      return redirectTo(path);
    }
    return redirectTo(ERROR403_PAGE_PATH);
  }
};
const PublicAccessMiddleware = ({ restricted }) => {
  const token = retrieveAuthToken();
  if (token && restricted) {
    const path = hasFirstAccessiblePage();
    return redirectTo(path);
  }
  return <Outlet />;
};

export { PublicAccessMiddleware, RouteAuthMiddleware };